import React, {useEffect} from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useCartActions} from './cart-utils'
import {useGetOnlive} from '../../custom-api/hooks/use-get-onlive'

export default function OnLive() {
    const {customParams} = getConfig() || {}
    const {onliveId} = customParams || ''
    const {addToCart: pwaAddToCart, applyCoupon: pwaApplyCoupon} = useCartActions()

    useGetOnlive()

    useEffect(() => {
        if (!onliveId) return
        createStyles()
        createScript(onliveId)
    }, [onliveId])

    useEffect(() => {
        if (!onliveId) return
        const scriptInterval = setInterval(() => {
            if (typeof window.onliveWtv === 'function') {
                clearInterval(scriptInterval) // Stop checking once the function is available
                initOnliveWtv(pwaAddToCart, pwaApplyCoupon, onliveId)
            } else {
                console.error('Waiting for onliveWtv function to load...')
            }
        }, 100) // Check every 100ms until the function is available

        return () => clearInterval(scriptInterval) // Cleanup on unmount
    }, [onliveId, pwaAddToCart])

    return (
        <Box w="100%" h="100%">
            <div id="onlive-landing"></div>
        </Box>
    )
}

const createScript = () => {
    if (document.getElementById('onlive-widget-script')) return

    const script = document.createElement('script')
    script.id = 'onlive-widget-script'
    script.innerHTML = `
    (function (w, d, s, o, f, js, fjs) {
        w.onliveWidgets = w.onliveWidgets || {};
        w['Onlive-Widget-tv'] = w.onliveWidgets['Onlive-Widget-tv'] = o;
        w[o] =
            w[o] ||
            function () {
                (w[o].q = w[o].q || []).push(arguments);
            };
        (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
        js.id = o;
        js.src = f;
        js.async = 1;
        fjs.parentNode.insertBefore(js, fjs);
    })(window, document, 'script', 'onliveWtv', "https://cdn.onlive.site/widget/v2/onlive-widget.js");
    `
    document.body.appendChild(script)
}

const initOnliveWtv = (pwaAddToCart, pwaApplyCoupon, onliveId) => {
    window.onliveWtv('init', {
        landing: true,
        targetElementId: 'onlive-landing',
        organizationId: onliveId,
        customs: {
            //checkout: function (instance, cartItems, discount, user) {
            checkout: function (instance, cartItems, discount) {
                const getbaseUrlUrl = () => {
                    const {origin, pathname} = window.location
                    const pathArray = pathname.split('/')
                    const baseUrl = `${origin}/${pathArray[1]}`
                    return baseUrl
                }

                //const addToCart = (code, qty, baseUrl) => {
                const addToCart = (code, qty) => {
                    pwaAddToCart(code, qty)
                }

                // const applyCoupon = (code, baseUrl) => {
                const applyCoupon = (code) => {
                    pwaApplyCoupon(code)
                }

                const baseUrl = getbaseUrlUrl()

                for (let i = 0; i < cartItems.length; i++) {
                    const item = cartItems[i]
                    addToCart(item.id, item.count, baseUrl)
                }

                //applying discount code if exists
                if (discount && discount.discountCode) {
                    applyCoupon(discount.discountCode, baseUrl)
                }

                // Returning a promise to resolve and navigate to checkout page
                //return new Promise((resolve, reject) => {
                return new Promise((resolve) => {
                    resolve(`${baseUrl}/checkout`)
                })
            },
        },
    })
}

const createStyles = () => {
    const styles = document.createElement('style')
    styles.setAttribute('data-testid', 'onlive-stylesheet')
    styles.innerHTML = `
    .onlive-landing, .event-title {
        font-family: inherit !important;
    }
    @media screen and (min-width: 1400px) {
        .onlive-landing-root .event-container .actionable-text {
            max-height: 100vh;
        }
        .onlive-landing-root .event-highlight > .event-container .container-img img {
            position: absolute;
            margin: auto;
            top: 0;
            bottom: 0;
        }
    }
    .onlive-landing-root .event-highlight > .event-container .container-img img {
        border-radius: var(--radius-big);
    }
    .onlive-landing-root .events-h-list {
        word-wrap: anywhere;
    }
    .dln-delonghi .dln-terms__content, .dln-terms__content {
        max-width: 100%;
        width: 100%;
        margin: auto;
    }
    `
    document.head.appendChild(styles)
}
